export function isIosDevice(navigatorLike = globalThis.navigator) {
  const userAgent = navigatorLike?.userAgent || '';
  const platform = navigatorLike?.platform || '';
  const touchPoints = Number(navigatorLike?.maxTouchPoints || 0);

  return /iPad|iPhone|iPod/i.test(userAgent) ||
    (platform === 'MacIntel' && touchPoints > 1);
}

export function isStandaloneMode(
  windowLike = globalThis.window,
  navigatorLike = globalThis.navigator
) {
  return Boolean(
    windowLike?.matchMedia?.('(display-mode: standalone)').matches ||
    navigatorLike?.standalone
  );
}

export function getInstallExperience({standalone, hasPrompt, ios}) {
  if (standalone) return 'installed';
  if (hasPrompt) return 'native';
  if (ios) return 'ios-help';
  return 'unavailable';
}
